import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../../component/Header";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import IconKey from "../../component/SvgIcons/IconKey";
import api from "../../services/axios";
import utils from "../../utils/utils";

export default function ViewAgentsDetails() {
  const { code } = useParams();
  console.log("🔍 Viewing Agent Code:", code);

  // States to hold agent data for display
  const [agent, setAgent] = useState({});
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [userType, setUserType] = useState("");
  const [agentCompany, setAgentCompany] = useState("");
  const [userRights, setUserRights] = useState([]);
  const [Extensions_Number, setExtensions_Number] = useState("");
  const [selectedFile, setSelectedFile] = useState(null); // to track new selection
  const [imagePreview, setImagePreview] = useState(""); // holds existing image URL (from backend)

  useEffect(() => {
    const fetchAgent = async () => {
      try {
        const res = await api.post("/list_agent", { Code: code });
        const allAgents = res.data.data;
        const found = allAgents.find((a) => a.Code === parseInt(code));
        if (found) {
          setAgent(found);

          // Populate form fields
          setName(found.Agent_Name || "");
          setEmail(found.Email_Id || "");
          // setPassword(found.Password || "");
          setPhone(found.Phone_No || "");
          setUserType(found.User_Type || ""); // adjust if property names differ
          setAgentCompany(found.Agents_Company || "");
          setExtensions_Number(found.Extensions_Number || "");
          // ✅ Compose full image URL from env variable
          const baseUrl = process.env.REACT_APP_IMAGE_URL || "";
          const fullImageUrl = found.Images
            ? `${baseUrl}/upload/${found.Images.replace(/^\/+/, "")}`
            : "";
          setImagePreview(fullImageUrl);

          try {
            const rightsArray = JSON.parse(found.User_Rights || "[]");
            setUserRights(rightsArray);
          } catch {
            setUserRights([]);
          }
        }
      } catch (err) {
        console.error("Error fetching agent:", err);
      }
    };

    fetchAgent();
  }, [code]);

  useEffect(() => {
    utils.saveRecentSearch("View Agent Details", window.location.pathname);
  }, []);

  return (
    <div className="dashboard">
      <Header
        title
        subtitle="View Agent Details"
        backbtn="/manage-agents"
        searchbar
      />
      <div className="center-content">
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <h2 className="create-titles mb-0 d-flex align-items-center">
              <DiamondsFour /> <span>View Agent Details</span>
            </h2>

            <AnimatePresence mode="wait">
              <motion.form
                className="myform d-flex flex-column justify-content-between"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <div className="create-form d-flex flex-column">
                  <div className="form-row d-flex justify-content-start justify-content-lg-between flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Agent"
                        value={name}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label>E-Mail ID</label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="agent@gmail.com"
                        value={email}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-row d-flex justify-content-start justify-content-lg-between flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                    <div className="form-group">
                      <label>Phone Number</label>
                      <input
                        type="tel"
                        name="phonenumber"
                        className="form-control"
                        placeholder="+6959154856"
                        value={phone}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label>User Type</label>
                      <input
                        type="text"
                        name="usertype"
                        className="form-control"
                        placeholder="Enter User Type"
                        value={userType}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label>Agents Company</label>
                      <input
                        type="text"
                        name="agentcompany"
                        className="form-control"
                        placeholder="Enter Agents Company"
                        value={agentCompany}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-row d-flex justify-content-start justify-content-lg-between flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                    <div className="form-group">
                      <label>Extensions_Number </label>
                      <input
                        type="tel"
                        name="Extensions_Number"
                        className="form-control"
                        placeholder="Extensions Number"
                        value={Extensions_Number}
                        readOnly
                      />
                    </div>

                    <div className="form-group d-flex justify-content-center gap-3 flex-column flex-md-row">
                      <AnimatePresence>
                        {selectedFile || imagePreview ? (
                          <motion.div
                            className="selected-file d-flex flex-column align-items-center justify-content-center gap-2"
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.3 }}
                          >
                            <a
                              href={
                                selectedFile
                                  ? URL.createObjectURL(selectedFile)
                                  : imagePreview
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              className="mb-2 text-decoration-underline text-primary"
                              title={
                                selectedFile
                                  ? selectedFile.name
                                  : imagePreview.split("/").pop()
                              }
                            >
                              {selectedFile
                                ? selectedFile.name
                                : imagePreview.split("/").pop()}
                            </a>

                            {/* ✅ Show image preview */}
                            <img
                              src={
                                selectedFile
                                  ? URL.createObjectURL(selectedFile)
                                  : imagePreview
                              }
                              alt="Agent"
                              style={{
                                maxHeight: "100px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                                objectFit: "contain",
                              }}
                            />
                          </motion.div>
                        ) : (
                          <div className="text-muted">No image available</div>
                        )}
                      </AnimatePresence>
                    </div>
                  </div>
                </div>

                <div className="form-savebtns d-flex justify-content-end flex-row align-items-center">
                  <Link to="/manage-agents" className="btn cancelbtn">
                    Back
                  </Link>
                </div>
              </motion.form>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}
